// extracted by mini-css-extract-plugin
export default {"wrap":"Header_wrap__dl+ry","title":"Header_title__r+iyF","user":"Header_user__utBk2","controls":"Header_controls__j8Y3N","logout":"Header_logout__OxpYS"};